exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal[data-v-028afd74] {\n  display: block;\n  z-index: 999;\n}\n.modal__title[data-v-028afd74] {\n    font-size: 1.3em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-028afd74","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/noomz/Projects/Opendream/kadnud/kadnud-eef-app/src/css"],"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modal.vue
// module id = 560
// module chunks = 1